<template>
  <Layout @componentKey="gotRefresh" @currentPage="currentPage" :hasPagination="true" :hasBreadcrumbs="true" :amount="amount.aantal" :amountToShow="amountToShow" :openModalHandler="openModalHandler">
    <div class="content">
      <div class="page-content" ref="tableContent">
        <MainTitle :title="this.$router.currentRoute.name"  />
        <MasterGrid @selectedAmount="gotAmountToShow" @selectedRow="gotDHR" :DHRDevices="DHRDevices" :totalItems="amount.aantal" @sorting="gotSorting" @refresh="gotRefresh" :isEditable="true" />
      </div>
    </div>
  </Layout>
</template>
<script>
// @ is an alias to /src
import Layout from "@/layouts/Dashboard";
import MasterGrid from "@/components/DeviceMasterGrid";
import MainTitle from "@/components/base/MainTitle";

export default {
  name: "production-master",
  props: {
    compKey: Number
  },
  data () {
    return {
      DHRDevices: [],
      amount: 0,
      selectedDHR: null,
      pagina: 1,
      openModalHandler: false,
      sortingOn: "ref",
      isAscending: true,
      amountToShow: 35
    }
  },
  components: {
    Layout,
    MasterGrid, 
    MainTitle, 
  },
  mounted() {
    this.getData()
  },
  methods: {
    gotAmountToShow(val) {
      this.amountToShow = parseInt(val)
      this.getData()
    },
    getData() {
      var that = this
      let offset = this.pagina != 1 ? (this.pagina * this.amountToShow) - this.amountToShow : 0
      let asc = this.isAscending ? "A" : "D"
      this.$http.get(this.$endpoint + 'management/devices/all/flows/' + this.amountToShow + '/' + offset)
      // this.$http.get(this.$endpoint + 'management/devices/all/' + this.sortingOn + '/' + asc + '/' + this.amountToShow + '/' + offset)
      .then(response => {
        console.log(response)
        that.amount = response.data.pop()
        that.DHRDevices = response.data
        that.selectedDHR = null
      })
      .catch(error => {
        if (error.response.status === 401) {
          this.$store
          .dispatch("logout")
          .then(() => this.$router.push("/login"))
          .catch(err => console.log(err));
        } else {
          that.$swal(
            'Oops that went wrong?',
            `Please contact the admin with the following info: ${ error }`,
            'error'
          );
        }
      })
    },
    currentPage(page) {
      this.pagina = page // someValue
    },
    gotSorting(sort) {
      this.isAscending = sort.asc
      this.sortingOn = sort.on
      this.getData()
    },
    gotDHR(dhr) {
      this.selectedDHR = dhr // someValue
    },
    gotClick(val) {
      this.openModalHandler = !this.openModalHandler;
    },
    gotRefresh(val) {
      this.pagina = 1
      this.amount = 0
      this.getData()
    },
    gotRefreshPageData(val) {
      this.getData()
    },
  },
  watch: {
    pagina: function (val) {
      this.getData()
    },
    amount: function (newVal, oldVal) {
      if(newVal.aantal != oldVal && newVal.aantal != oldVal.aantal && oldVal != 0) {
        this.getData()
      }
    },
  }
};
</script>
<style lang="scss" scoped>
@import "@/style/base.scss";
@import "@/style/pages/content.scss";
@import "@/style/components/sidebar.scss";
/* 
.sidebar {
  background-color: red;
} */
</style>;
